import { StackDialogProvider } from "@k3-tech/react-kit";
import PricelistSalesChannelMarkupCard from "../components/PricelistSalesChannelMarkupCard";

export default function PricelistSalesChannelListContainer({
	pricelistID,
	onSaved,
}: {
	pricelistID?: string;
	onSaved?: () => void;
}) {
	return (
		<StackDialogProvider>
			<PricelistSalesChannelMarkupCard
				pricelistID={pricelistID}
				onSaved={onSaved}
			/>
		</StackDialogProvider>
	);
}
